import { useReport } from './hooks/use-context';

export function Header() {
  const { header } = useReport();

  if (!header) return null;

  return (
    <div
      style={{
        marginBottom: '1rem',
        display: 'flex',
        width: '100%',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '2rem',
        color: 'black',
      }}
    >
      <div>
        <h1
          style={{
            fontSize: '1.5rem',
            fontWeight: 'bold',
            lineHeight: '1.25',
            color: '#000',
          }}
        >
          Comunicado Incidente e/ou Ato Inseguro
        </h1>
        <p
          style={{
            fontSize: '1rem',
            lineHeight: '1.25',
            color: '#000',
            marginTop: '0.5rem',
          }}
        >
          <strong>Documento:</strong> FORMU-0650 &nbsp;&nbsp;&nbsp;
          <strong>Revisão:</strong> 04 &nbsp;&nbsp;&nbsp;
          <strong>Data:</strong> {header?.event_finished_at}
        </p>
      </div>
      <img
        style={{
          height: 'auto',
          width: '11rem',
        }}
        src={header?.logo}
        alt="logo"
      />
    </div>
  );
}
